import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';


import { CheckContractorLicense, IContact, IContactInput } from '@ebb-v2/ebb-integration';

import { Apollo } from 'apollo-angular';
import {
  ListContactsQuery,
  GetContactByIdQuery,
  CONTACT_MUTATION, CONTACT_CONTRACTOR_UNLISTED_MUTATION
} from '@ebb-v2/ebb-integration';
import { ContactApiService } from '../data-services/contact-api.service';

@Injectable({
  providedIn: 'root'
})
export class ContactGqlService implements ContactApiService {
  currentUser: Observable<IContact>;

  constructor(private apollo: Apollo) {}

  public getContact(id: string, resetCache:boolean): Observable<IContact> {
    //console.log(`ContactGql.getContact()`);
    return this.apollo
      .query({
        query: GetContactByIdQuery,
        variables: {
          id: id,
          resetCache: resetCache
        },
        fetchPolicy: 'network-only'
      })
      .pipe( map(result => result.data['contact'] as IContact), take(1) );
  }


  public updateContact(contact: IContactInput): Observable<IContact> {
    //console.log(`ContactGql.saveContact()`);
    return this.apollo
      .mutate({
        mutation: CONTACT_MUTATION,
        variables: {
          contact
        }
      })
      .pipe(map(result => result.data['saveContact'] as IContact));
  }



}
